import HTTPService from "../utility/httpService";
import { apiEndPointConstants, keyConstants } from "../constants";
import Utils from "../utility";
const {
  USER,
  FORGOT_PASSWORD,
  BUSINESS,
  CHANGE_PASSWORD,
  LOGO,
  SETTINGS,
  CHECK_BUSINESS_EXISTS,
  RESEND_VERIFY
} = apiEndPointConstants;
const { TOKEN } = keyConstants;

export default class UserService {
  /**
   * Initializes a new instance of the class.
   *
   * @param {type} token - The token used for authorization.
   */
  constructor(token) {
    this.httpService = new HTTPService(process.env.REACT_APP_USER_MICROSERVICE);
    this.config = {
      headers: {
        Authorization: `Bearer ${
          token !== undefined ? token : Utils.cookieGetItem(TOKEN)?.access_token
        }`,
        "X-Api-Key": process.env.REACT_APP_X_API_KEY
      }
    };
  }

  /**
   * Retrieves a user by their ID.
   *
   * @param {number} id - The ID of the user.
   * @returns {Promise} A promise that resolves to the user data.
   */
  getUser(id) {
    const url = `${BUSINESS}${USER}/${encodeURIComponent(id)}`;
    const requestBody = {};
    const headers = this.config;

    return this.httpService.get(url, requestBody, headers);
  }
  /**
   * Updates a user's status.
   *
   * @param {string} id - The ID of the user.
   * @param {boolean} isActive - The new status of the user.
   * @return {Promise} A promise that resolves with the updated user data.
   */
  putUser(payload) {
    return this.httpService.put(`${BUSINESS}`, payload, this.config);
  }
  /**
   * Sends a request to reset the password for a user.
   *
   * @param {string} email - The email address of the user.
   * @return {Promise} - A promise that resolves with the response from the server.
   */
  resetPassword(requestData) {
    return this.httpService.post(FORGOT_PASSWORD, requestData, this.config);
  }

  /** Send verification mail **/
  sendVerificationMail(requestData) {
    return this.httpService.post(RESEND_VERIFY, requestData, this.config);
  }

  /**
   * changePassword - A function that changes the user's password.
   *
   * @param {Object} payload - The data required to change the password.
   * @return {Promise} - A promise that resolves to the response of the HTTP request.
   */
  changePassword(payload) {
    return this.httpService.post(CHANGE_PASSWORD, payload, this.config);
  }
  /**
   * Update the profile using the provided payload.
   * @param {Object} payload - The payload object containing the data to be updated.
   * @returns {Promise} A Promise that resolves to the result of the PUT request.
   */
  updateProfile(payload) {
    return this.httpService.put(BUSINESS, payload, this.config);
  }
  /**
   * Uploads a logo using the provided payload.
   *
   * @param {FormData} payload - the data to be sent in the request
   * @return {String} the response from the server
   */
  uploadLogo(payload) {
    return this.httpService.post(LOGO, payload, this.config);
  }

  /**
   * Retrieves a business deatils by businessId.
   *
   * @param {string} businessId - The ID of the business.
   * @returns {Promise} A promise that resolves to the user data.
   */
  getBusiness(businessId) {
    const url = `${BUSINESS}/${businessId}`;
    const requestBody = {};
    const headers = this.config;

    return this.httpService.get(url, requestBody, headers);
  }

  /**
   * Update the business settings with the provided payload.
   *
   * @param {string} businessId - The ID of the business whose settings will be updated.
   * @param {Object} payload - The payload containing the updated widget settings for the business.
   * @returns {Promise} A Promise that resolves with the result of the PUT request.
   */
  updateBusinesssettings(businessId, payload) {
    return this.httpService.put(
      `${BUSINESS}/${businessId}${SETTINGS}`,
      payload,
      this.config
    );
  }
  checkBusinessExists(requestData) {
    const url = `${CHECK_BUSINESS_EXISTS}`;
    const headers = this.config;

    return this.httpService.post(url, requestData, headers);
  }
}
